@if (!$hideTitle()) {
  <div class="sheet-header headline-large pueblo-font on-surface-text">
    Add interests
  </div>
}

<form [formGroup]="form" novalidate>
  <div class="form-body no-scrollbar">
    <interest-select
      [formPath]="['interests']"
      [excludeInterests]="$appUser().interests"
      [lines]="5"
    >
    </interest-select>

    <div class="form-actions">
      <button
        mat-button
        class="error-button cancel-btn enable-with-keyboard"
        type="button"
        (click)="cancel.emit()"
      >
        Cancel
      </button>
      <button
        class="submit-btn enable-with-keyboard"
        mat-flat-button
        color="primary"
        (click)="onSubmit()"
      >
        Add interests
      </button>
    </div>
  </div>
</form>
